import { IconWrapper } from "@insite/mobius/Icon";
import { ToastPresentationProps } from "@insite/mobius/Toast";
import { ToasterPresentationProps } from "@insite/mobius/Toast/Toaster";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { buttonIconOnlyCommonStyles } from "@solveindustrial/Utilities/styleguide";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

export const toast: RecursivePartial<{
    defaultProps?: ToastPresentationProps | undefined;
    toasterProps?: ToasterPresentationProps | undefined;
}> = {
    defaultProps: {
        mergeCss: true,
        cssOverrides: {
            toastBody: css`
                && {
                    width: calc(100% - 66px);
                    margin-right: 10px;
                }
            `,
        },
        closeButtonProps: {
            ...buttonIconOnlyCommonStyles,
            css: css`
                padding: 0;
                margin: 5px;
                width: auto;
                height: 100%;
                background-color: transparent;
                border: 0;
                ${IconWrapper} {
                    color: ${getColor(colorStrings.primaryMain)};
                }

                &&:hover,
                &&:focus,
                &&:active {
                    background-color: transparent;
                    outline: none;
                    ${IconWrapper} {
                        color: ${getColor(colorStrings.commonPrimarySecond)};
                    }
                }
            `,
        },
        closeButtonIconProps: {
            src: "X",
            size: 24,
            color: colorStrings.primaryMain,
            css: css`
                &:hover,
                &:focus,
                &:active {
                    background-color: transparent;
                    ${IconWrapper} {
                        color: ${getColor(colorStrings.commonPrimarySecond)};
                    }
                }
            `,
        },
    },
};
